import { FormInputNumber } from "../../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormUnitInput } from "../../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../../../config/constants";
import {
  isCheckPercentageIrrigation,
  validateInternalStorage,
  valueGraterThanZero
} from "../../../../../../utils/utils";
import { InternalStorageSectionProps, InternalStorageVariantFeatures } from "../internalStorage.types";

interface InternalStorageMetricsSectionProps extends InternalStorageSectionProps {
  variantConfig: InternalStorageVariantFeatures;
  isDefaultDataType: boolean;
}

const InternalStorageMetricsSection = ({
  control,
  disabled,
  variantConfig,
  isDefaultDataType
}: InternalStorageMetricsSectionProps) => (
  <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
    <FormInputNumber
      control={control}
      name="temperature"
      label="Storage Temperature (℃)"
      placeholder="Storage Temperature (℃)"
      disabled={disabled}
      enableMinus
      enableDecimalWithMinus
      rules={{
        validate: {
          valueCheck: (value: unknown) => validateInternalStorage(value, true) || true
        }
      }}
    />

    {isDefaultDataType && (
      <FormInputNumber
        control={control}
        name="warehouseSize"
        label="Warehouse size (m3)"
        placeholder="Warehouse size (m3)"
        disabled={disabled}
        rules={{
          validate: {
            valueCheck: (value: unknown) => validateInternalStorage(value) || true
          }
        }}
      />
    )}

    {variantConfig.supportsWeightUnit ? (
      <FormUnitInput
        control={control}
        name="weight"
        unitName="weightUnit"
        label="Weight"
        placeholder="0"
        required
        disabled={disabled}
        errorMessage="Weight is required"
        unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
        unitRequired
        validate={{
          decimalValidation: (value: unknown) => validateInternalStorage(value) || true,
          valueCheck: (value: unknown) =>
            valueGraterThanZero(value) || "Weight must be greater than zero"
        }}
      />
    ) : (
      <FormInputNumber
        control={control}
        name="weight"
        label="Weight (kg)"
        placeholder="Weight (kg)"
        required
        disabled={disabled}
        errorMessage="Weight is required"
        rules={{
          validate: {
            valueCheck: (value: unknown) => validateInternalStorage(value) || true
          }
        }}
      />
    )}

    {isDefaultDataType && (
      <>
        <FormInputNumber
          control={control}
          name="electricity"
          label="Electricity (kWh/hr)"
          placeholder="0"
          required
          disabled={disabled}
          errorMessage="Electricity is required"
          rules={{
            validate: {
              decimalValidation: (value: unknown) => validateInternalStorage(value) || true,
              valueCheck: (value: unknown) =>
                valueGraterThanZero(value) || "Electricity must be greater than zero"
            }
          }}
        />
        <FormInputNumber
          control={control}
          name="areaUtilization"
          label="Utilization of warehouse %"
          placeholder="Utilization of warehouse %"
          required={isDefaultDataType}
          disabled={disabled || !isDefaultDataType}
          errorMessage="Utilization is required"
          rules={{
            validate: {
              valueCheck: (value: unknown) =>
                isDefaultDataType
                  ? isCheckPercentageIrrigation(value) ||
                    "Utilization must be less than or equal to 100"
                  : true
            }
          }}
        />
      </>
    )}

    <FormInputNumber
      control={control}
      name="storageDays"
      label="Storage day(s)"
      placeholder="Storage day(s)"
      required
      disabled={disabled}
      removeDecimal
      errorMessage="Storage days is required"
      rules={{
        validate: {
          valueCheck: (value: unknown) =>
            valueGraterThanZero(value) || "Storage days must be greater than zero",
          decimalValidation: (value: unknown) => validateInternalStorage(value) || true
        }
      }}
    />
  </div>
);

export default InternalStorageMetricsSection;
